import { Injectable, ChangeDetectorRef, ComponentFactoryResolver } from '@angular/core';
import 'rxjs/add/operator/map';
import { ConfigProvider } from '../config/config';
import { RequestProvider } from '../request/request';
import { TranslateService } from '@ngx-translate/core';
import { ThrowStmt } from '@angular/compiler';
import { StorageProvider } from '../storage-service/storage-service';
import { Cache } from '../../assets/data/cache-key/cache-key';
import { CANCELLED } from 'dns';

/*
  Generated class for the CategoriesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

export interface CategoryModel {
  id: number;
  name: string;
  uniqueName: string;
}

@Injectable()
export class CategoriesProvider {

  constructor(private translate: TranslateService, public request: RequestProvider, private strg: StorageProvider, public config: ConfigProvider, private translateService: TranslateService) { }

  public async getEventCategoires(): Promise<CategoryModel[]> {
    if (!this.eventPromise) {
      if (!navigator.onLine) return this.eventPromise = this.strg.getSaved(Cache.EVENT_CATEGORIES).then(r => r);
      else {
        this.eventPromise = this.request
          .getApiSimple<CategoryModel[]>('event/categories?page=1&start=0&limit=25')
          .then(values => {
            this.strg.saveData(values, Cache.EVENT_CATEGORIES);
            return this.translateCategories(values)
          });
      }
    }

    return this.eventPromise;
  }
  public async getResultCategoires(): Promise<CategoryModel[]> {
    if (!this.resultPromise) {
      const lang = this.translate.getDefaultLang();
      if (!navigator.onLine) return this.resultPromise = this.strg.getSaved(Cache.RESULT_CATEGORIES).then(r => r);
      else {
        this.resultPromise = this.request
          .getApiSimple<CategoryModel[]>(`event/result/categories/${lang}?page=1&start=0&limit=25`)
          .then(values => {
            this.strg.saveData(values, Cache.RESULT_CATEGORIES);
            return this.translateCategories(values);
          });
      }
    }
    return this.resultPromise;
  }

  public async getCategoriesByLang(lang): Promise<CategoryModel[]> {
    return new Promise<any>((resolve, reject) => {
      return this.request.getApiSimple(`route/categories/${lang}`, {}, 2000, "event")
        .then(values => {
          resolve(values)
        }).catch((error) => {
          resolve([]);
        });
    });
  }


  public async getProfileCategoires(): Promise<CategoryModel[]> {
    return new Promise<any>((resolve, reject) => {
      this.request.get("assets/data/categories/categories.ts")
        .toPromise()
        .then(values => {
          resolve(values)
        }).catch((error) => {
          resolve([]);
        });
    });
  }

  profilePromise: Promise<CategoryModel[]>;
  eventPromise: Promise<CategoryModel[]>;
  resultPromise: Promise<CategoryModel[]>;

  allCategories: Promise<CategoryModel[]>;
  getAllCategories(): Promise<CategoryModel[]> {
    if (!this.allCategories) {
      this.allCategories = Promise.all([
        this.getEventCategoires(),
        this.getResultCategoires(),
        this.getProfileCategoires()
      ]).then(values => {
        return (values[0] && values[1] && values[2]) ? values[0].concat(values[1]).concat(values[2]) : [];
      });
    }
    return this.allCategories;
  }

  translateCategories(categories: CategoryModel[]) {
if(typeof categories === "undefined") return [];
    for (let i = 0; i < categories.length; i++) {
      const category = categories[i];
      this.changeCategory(category);
    }
    return categories;
  }

  changeCategory(category: CategoryModel) {
    category.uniqueName =
      'CATEGORY_' +
      category.uniqueName
        .toUpperCase()
        .replace('EVENTS', '')
        .replace('RESULTS', '')
        .replace('SPORTHEROS', '');
  }


}



// WEBPACK FOOTER //
// /src/providers/categories/categories.ts